import { render } from "./BackorderCartRow.vue?vue&type=template&id=24308a62"
import script from "./BackorderCartRow.vue?vue&type=script&lang=js"
export * from "./BackorderCartRow.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__